export enum CheckboxStatus {
  NONE = 0,
  UNCHECKED = 1,
  CHECKED = 2,
  INDETERMINATE = 3,
}
